import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "aidesefang_favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

/**
 * 电影收藏（仅存于浏览器本地，不跨设备同步）。
 */
export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore storage errors
    }
  }, []);

  const toggleFavorite = useCallback(
    (movieId: string) => {
      const current = readFavorites();
      const next = current.includes(movieId)
        ? current.filter((id) => id !== movieId)
        : [...current, movieId];
      persist(next);
      return next.includes(movieId);
    },
    [persist]
  );

  const isFavorite = useCallback(
    (movieId: string) => favorites.includes(movieId),
    [favorites]
  );

  return { favorites, toggleFavorite, isFavorite };
}

export default useFavorites;